// File: src/pages/AdminDashboard.js
import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../assets/css/AdminDashboard.css';

const AdminDashboard = () => {
  return (
    <div className="dashboard-wrapper">
      <Header />

      <div className="dashboard-content">
        <aside className="dashboard-sidebar">
          <ul className="sidebar-nav">
            <li>
              <NavLink to="" end className="nav-item">
                Dashboard
              </NavLink>
            </li>
            <li>
              <NavLink to="users" className="nav-item">
                Users
              </NavLink>
            </li>
            <li>
              <NavLink to="posts" className="nav-item">
                Posts
              </NavLink>
            </li>
            <li>
              <NavLink to="sponsored" className="nav-item">
                Sponsored
              </NavLink>
            </li>
            <li>
              <NavLink to="report" className="nav-item">
                Reports
              </NavLink>
            </li>
            <li>
              <NavLink to="settings" className="nav-item">
                Settings
              </NavLink>
            </li>
         
          </ul>
        </aside>

        {/* Main content area for nested routes */}
        <main className="dashboard-main">
          <Outlet />
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default AdminDashboard;
